// removed by extract-text-webpack-plugin
module.exports = {"background":"src-pages-features-collaboration-style----general-module---background---3U8fb"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/features/collaboration/style/general.module.css
// module id = 752
// module chunks = 157577309833566 171778037205648